import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
          准备好发现更多精彩内容了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-xl mx-auto">
          加入我们，探索最热门的国产自拍视频，发现真实、有趣、有温度的本土原创内容
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/life-record"
            className="px-8 py-3 bg-background-50 text-primary-600 rounded-full text-sm font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始浏览
            <i className="ri-play-circle-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-primary-600 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            联系创作者
          </Link>
        </div>
      </div>
    </section>
  );
}